import {
  AfterRenderPhase,
  AfterViewInit,
  CUSTOM_ELEMENTS_SCHEMA,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnDestroy,
  ViewChild,
  afterRender,
  computed,
  inject,
  input,
  signal,
} from '@angular/core';
import { ContentBlockBaseComponent } from '../content-block-base/content-block-base.component';
import { JsonPipe, NgClass } from '@angular/common';
import { EventCardComponent } from 'src/app/events/components/event-card/event-card.component';
import { RouterLink } from '@angular/router';
import { SwiperContainer } from 'swiper/element';
import { FreeMode, Scrollbar } from 'swiper/modules';

import { register } from 'swiper/element/bundle';
import { SwiperOptions } from 'swiper/types';
import { IconComponent } from '@teamfoster/sdk/icon';
import { ContentBlock } from '../../models';
import { CtaCardComponent } from '../cta-card/cta-card.component';
register();
@Component({
  selector: 'app-content-block-cta-cards',
  templateUrl: './content-block-cta-cards.component.html',
  styleUrls: ['./content-block-cta-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [JsonPipe, RouterLink, IconComponent, NgClass, CtaCardComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ContentBlockCtaCardsComponent extends ContentBlockBaseComponent {
  // block = input<ContentBlock[]>();

  get ctaCardsColumns() {
    const cards = this.block().ctaItems;
    if (!cards) {
      return;
    }

    if (this.block().compact) {
      return ' col-24 col-sm-12 col-lg-6';
    }

    switch (cards.length) {
      case 1:
        return 'col-md-24';

      default:
        return 'col-md-12';
    }
  }
}
